export default "__VITE_ASSET__BbzPKFj6__"